import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './styles.css';

const SUPPORTS_SMOOTH_SCROLL = typeof CSS !== 'undefined' && CSS.supports('scroll-behavior', 'smooth');

/**
 * A styled anchor tag for navigation.
 *
 * @typedef {Object} Props
 * @prop {String} href
 *
 * @augments {Component<Props>}
 */
export default class NavItem extends Component {

	componentDidMount () {
		if (!SUPPORTS_SMOOTH_SCROLL && this.isHashLink) this.setupSmoothScroll();
	}

	handleClick = (event) => {
		if (this.anchorRef) {
			event.preventDefault();

			/* NOTE: The following code:
			 * 1: stores the current scroll position,
			 * 2: sets the hash (so that the adress bar updates appropriately), and then
			 * 3: scrolls to the correct position. */
			const prevScrollYPos = window.scrollY;
			const top = this.anchorRef.parentElement.offsetTop + this.anchorRef.offsetTop;

			window.location.hash = this.props.href;
			window.scrollTo(0, prevScrollYPos);
			requestAnimationFrame(() => window.scrollTo({ behavior: 'smooth', top }));
		}
	}

	isHashLink = this.props.href.includes('#');

	isExternalLink = this.props.href.includes('http');

	setMatchingElement = (idWithHash) => {
		const id = idWithHash.substr(1);
		this.anchorRef = document.getElementById(id);
	}

	setupSmoothScroll = async () => {
		const smoothScroll = await import('smoothscroll-polyfill');
		smoothScroll.polyfill();
		this.setMatchingElement(this.props.href);
	}

	render () {
		const { children, href } = this.props;

		// for external links.
		if (this.isExternalLink) {
			return <a className='NavItem' href={href}>{children}</a>;
		}

		// For standard navigation links.
		if (!this.isHashLink) {
			return <Link className='NavItem' to={href}>{children}</Link>;
		}

		// For hash links.
		const props = { href };
		if (!SUPPORTS_SMOOTH_SCROLL) props.onClick = this.handleClick;
		return <a className='NavItem' {...props}>{children}</a>;
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/NavItem/NavItem.js